module.exports = __webpack_public_path__ + "static/img/f.30b8820.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/f.png
// module id = Si07
// module chunks = 1